<template>
  <ul class="video-list flex flex-wrap">
    <li v-for="(item, index) in fileList" :key="index">
      <video
        controls
        playsinline
        :src="item.url"
        webkit-playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
      >
        <source :src="item.url" type="video/mp4" />
        <source :src="item.url" type="video/ogg" />
        <source :src="item.url" type="video/mov" />
      </video>
      <a class="del" href="javascript:;" @click="del(fileList, index)">
        <van-icon name="cross" />
      </a>
    </li>
    <li>
      <van-uploader
        v-model="fileList"
        accept="video/*"
        :after-read="afterRead"
        :max-count="maxCount"
        :max-size="maxSize"
        name="FormFile"
        :preview-image="false"
        upload-icon="video"
        upload-text="上传视频"
        @oversize="onOversize"
      />
    </li>
  </ul>
</template>
<script>
  import { onMounted, reactive, ref, toRefs, watch } from 'vue'
  import axios from 'axios'
  import store from '@/store'
  import api from '@/api'
  import { Notify, Toast, Uploader } from 'vant'
  import { getCompressImage } from '@/utils'
  export default {
    props: {
      file: {
        type: String,
        default: '',
      },
      maxCount: {
        type: Number,
        default: 9,
      },
      maxSize: {
        type: Number,
        default: 200 * 1024 * 1024,
      },
    },
    setup(props, ctx) {
      const fileList = ref([])
      const { file } = toRefs(props)
      const init = ref(false)

      const fileInit = (val) => {
        if (val) {
          const arr = []
          val.split(',').forEach((item) => {
            arr.push({
              url: api.FileHost + item,
              status: 'success',
              backUrl: item,
            })
          })
          fileList.value = arr
        }
      }

      watch(file, (newVal) => {
        fileInit(newVal)
      })

      const afterRead = (file) => {
        if (Array.isArray(file)) {
          file.forEach((item) => {
            upload(item)
          })
        } else {
          upload(file)
        }
      }

      const onOversize = (file) => {
        const size = props.maxSize / (1024 * 1024)
        Notify({ type: 'danger', message: `文件大小超过最大${size}M限制` })
      }

      const callback = () => {
        const list = []
        let allUploadDone = true
        fileList.value.forEach((item) => {
          if (item.status != 'success') {
            allUploadDone = false
          }
          list.push(item.backUrl)
        })
        // 当存在同时上传多个文件时 等待全部上传完
        if (allUploadDone) {
          ctx.emit('update:file', list.join(','))
        }
      }

      const upload = async (file) => {
        file.status = 'uploading'
        file.message = '上传中...'
        //const blob = await compressImage(file.file)
        const loading = Toast.loading({
          duration: 0,
          message: '上传中...',
          forbidClick: false,
          overlay: true,
        })
        const param = new FormData()
        param.append('formFile', file.file, file.file.name)
        console.log(param)
        const token = store.getters['user/token']
        axios({
          method: 'POST',
          url: api.UploadVideo,
          data: param,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
          //原生获取上传进度的事件
          onUploadProgress: (progressEvent) => {
            //this.showProcess = true
            let process =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
            const progress = `上传中:${process}%`
            loading.message = progress
          },
        })
          .then(({ data }) => {
            loading.clear()
            if (data.Code === 0) {
              file.backUrl = data.Data
              file.status = 'success'
              file.message = '上传成功'
              callback()
            } else {
              file.status = 'failed'
              file.message = '上传失败'
              Notify({ type: 'danger', message: data.Message })
            }
          })
          .catch((e) => {
            loading.clear()
            file.status = 'failed'
            file.message = '上传失败'
            Notify({ type: 'danger', message: '上传失败' + e.Message })
          })
      }

      /**
       * 压缩
       * @author hanson.liu
       * @date 2021-09-23
       * @param {any} file
       * @returns {any} Promise 小于2M的图片
       */
      const compressImage = (file) => {
        return new Promise((resolve, reject) => {
          // 小于2M直接上传
          if (file.size < 1024 * 1024 * 2) {
            resolve(file)
            return
          }
          let image = new Image()
          let resultBlob = ''
          image.src = URL.createObjectURL(file)
          image.onload = () => {
            let quality = 0.9
            // 调用方法获取blob格式，方法写在下边
            resultBlob = getCompressImage(image, file, quality)
            resolve(resultBlob)
          }
          image.onerror = () => {
            reject()
          }
        })
      }

      const del = (fileList, index) => {
        fileList.splice(index, 1)
        callback()
      }

      return {
        fileList,
        afterRead,
        onOversize,
        del,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .video-list {
    margin: 0 -3px;
    li {
      width: 86px;
      margin-bottom: 6px;
      box-sizing: border-box;
      position: relative;
      padding: 0 3px;
      video {
        width: 100%;
        display: block;
        border-radius: 3px;
        overflow: hidden;
        min-height: 120px;
        background: #f1f1f1;
      }
      .del {
        position: absolute;
        right: 3px;
        top: 0;
        z-index: 1024;
        background: rgba($color: #000000, $alpha: 0.3);
        width: 26px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        border-radius: 0 3px 0 3px;
        color: #fff;
      }
    }
  }
</style>
